








































































































import {
    defineComponent,
    PropType,
    ref,
    onBeforeUnmount,
    onMounted,
    computed,
} from '@vue/composition-api';
import { OddValueChange } from '@store/modules/data/sportOffer/enums';
import {
    SdsContentLoader,
    ContentLoaderSize,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import OddDirectionImg from './OddDirectionImg.vue';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { useOddObserver } from '@shared/composables/feedPersonalizationAnalytics/useOddObserver';
import {
    OddStatus,
    doneOddStatuses,
} from '@core/models/shared/odds/OddStatus';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    ClickName,
    ExperimentsGroup,
} from '@superbet-group/product.analytics';
import { getPe131DescriptiveOddButtonVariant } from '@app/shared/featureFlags/pe131DescriptiveOddButtonFlag';

const directionToClass: Record<OddValueChange, string> = {
    [OddValueChange.up1]: 'up1',
    [OddValueChange.up2]: 'up2',
    [OddValueChange.down1]: 'down1',
    [OddValueChange.down2]: 'down2',
};

export default defineComponent({
    name: 'OddButton',
    inheritAttrs: false,
    props: {
        isDisabled: {
            type: Boolean,
            required: true,
        },
        isLocked: {
            type: Boolean,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false,
        },
        changeDirection: {
            type: Number as PropType<OddValueChange>,
            required: false,
            default: undefined,
        },
        id: {
            type: [Number, String],
            required: true,
        },
        uuid: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: null,
        },
        displayValue: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        tooltipDescription: {
            type: String,
            required: false,
            default: '',
        },
        status: {
            type: String,
            required: false,
            default: '',
        },
        tag: {
            type: String,
            required: false,
            default: 'button',
        },
    },
    setup(props) {
        const { observedElementRef, visibleOdds } = useOddObserver();

        const getDirectionClass = (changeDirection?: OddValueChange) => {
            return changeDirection ? directionToClass[changeDirection] : null;
        };

        function isFinished() {
            return doneOddStatuses[props.status as OddStatus];
        }

        function handleClick() {
            // we dont want to send analytic if the odd is unselected or if the event is finished
            if (!props.isSelected && !isFinished()) {
                AnalyticsSDK.getInstance().log('click', {
                    click_name: ClickName.CLICK_NAME_UNSPECIFIED,
                    click: {
                        click_name: 'feed_personalisation_add_to_betslip',
                        click_value_1: props.uuid,
                        click_value_2: visibleOdds.value.filter((id) => id !== props.uuid).toString(),
                        type: 'test_click',
                    },
                });
            }
        }

        const showPriceForLockedOdds = ref(true);
        let featureSubscriptionUnsubscribeFn: () => void;
        onMounted(() => {
            featureSubscriptionUnsubscribeFn = featureFlagService.subscribeToFeatureChanges('web.show-price-for-locked-odds', (isEnabled) => {
                showPriceForLockedOdds.value = isEnabled;
            }, false);
        });

        onBeforeUnmount(() => featureSubscriptionUnsubscribeFn?.());

        return {
            maxUnclippedDisplayValueLength: 12,
            ContentLoaderSize,
            showPriceForLockedOdds,
            observedElementRef,
            handleClick,
            getDirectionClass,
            applyPe131StyleChanges: computed(() => getPe131DescriptiveOddButtonVariant() === ExperimentsGroup.B),
        };
    },
    components: {
        OddDirectionImg,
        SdsContentLoader,
        SdsIcon,
    },
});
